import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { UserListItemDto } from '../../types/api';
import { apiGet } from '../../config/api';

export type UserItem = UserListItemDto;

export interface UserState {
  loading: boolean;
  items: UserItem[];
  error: string | null;
  operationLoading: {
    list: boolean;
  };
  errors: {
    list: string | null;
  };
}

const initialState: UserState = {
  loading: false,
  items: [],
  error: null,
  operationLoading: { list: false },
  errors: { list: null },
};

/** GET /api/User — list users */
export const getUsers = createAsyncThunk(
  'user/getUsers',
  async (_, { rejectWithValue }) => {
    try {
      return await apiGet<UserItem[]>('/api/User');
    } catch (e) {
      return rejectWithValue(e instanceof Error ? e.message : 'Kullanıcılar yüklenirken hata oluştu');
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUserError: (state) => {
      state.error = null;
      state.errors = { list: null };
    },
    clearUserItems: (state) => {
      state.items = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUsers.pending, (state) => {
      state.operationLoading.list = true;
      state.error = null;
      state.errors.list = null;
    });
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.operationLoading.list = false;
      state.items = Array.isArray(action.payload) ? action.payload : [];
      state.errors.list = null;
    });
    builder.addCase(getUsers.rejected, (state, action) => {
      state.operationLoading.list = false;
      const msg = typeof action.payload === 'string' ? action.payload : 'Kullanıcılar yüklenirken hata oluştu';
      state.error = msg;
      state.errors.list = msg;
    });
  },
});

export const { clearUserError, clearUserItems } = userSlice.actions;
export default userSlice.reducer;
